const constructBeneficiaries = beneficiaries => {
  const beneficiariesList = beneficiaries
    ? beneficiaries.map(b => ({
        amount: b.amount,
        code: b.beneficiaryCode,
        name: b.beneficiaryName
      }))
    : [];

  const beneficiariesTotalAmount = beneficiaries
    ? beneficiaries
        .map(beneficiary => beneficiary.amount)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    : 0;

  return {
    list: beneficiariesList,
    totalAmount: beneficiariesTotalAmount
  };
};

export { constructBeneficiaries };
